/* Inner Echo — pin ?first= product into collection slot #1
   Fallback path only: runs when the product isn't already on this page,
   or when a variant needs to be applied. Otherwise does nothing. */
(function () {
  var pin = window.InnerEchoPin;
  if (!pin || !pin.handle) return;

  function applyVariantLinks(li) {
    if (!pin.variant) return;
    li.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        u.searchParams.set('variant', pin.variant);
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    });
  }

  /* Swap in the variant's image so the tile matches the ad creative. */
  function applyVariantImage(li) {
    var src = li.getAttribute('data-pin-image');
    if (!src) return;
    var img = li.querySelector('.card__media img');
    if (!img) return;
    img.setAttribute('src', src);
    var srcset = li.getAttribute('data-pin-image-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    var alt = li.getAttribute('data-pin-image-alt');
    if (alt) img.setAttribute('alt', alt);
  }

  function run() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    var existing = grid.querySelector('li[data-pin-handle="' + pin.handle + '"]');

    /* Already on this page and no variant requested:
       the CSS rule from the section already moved it. Nothing to fetch. */
    if (existing && !pin.variant) {
      pin.pinned = true;
      return;
    }

    var url = '/products/' + encodeURIComponent(pin.handle) + '?view=pinned-card';
    if (pin.variant) url += '&variant=' + encodeURIComponent(pin.variant);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html.trim();
        var li = tpl.content.querySelector('li[data-pin-injected="true"]');
        if (!li) return;

        applyVariantImage(li);
        applyVariantLinks(li);

        if (existing) {
          existing.replaceWith(li);
        } else {
          grid.insertBefore(li, grid.firstElementChild);
        }
        pin.pinned = true;
      })
      .catch(function () {
        /* Invalid or unavailable product — leave the normal collection alone. */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();